export const getUserIdFromToken = () => {
    try {
        const token = localStorage.getItem("objectId");
        if (!token) return null;

        const base64Payload = token.split('.')[1];
        const decodedData = JSON.parse(atob(base64Payload));

        return decodedData.userId;
    } catch (error) {
        console.error("Error decoding JWT token:", error);
        return null;
    }
};